module.exports = __webpack_public_path__ + "img/shape-8_yellow-400.9c78a0b.png";